import _forEach from 'lodash/forEach';
import templateCompiler from './template-compiler';

const lodash = { _forEach };

const html = `
<div class="<%= classes.option %> is-span is-preview-text">
  <label class="<%= classes.label %>">
    <%= title %>
  </label>
  <div class="<%= classes.values %>">
    <% _forEach(values, function (value){ %>
      <button class="<%= value.classes.all %> is-span is-preview-text <%= (value.variant.image_id ? 'is-img' : 'is-text') %>" <%= value.controls %>
        <%= value.state %>
          >
            <% if(value.imageFromVariant && value.variant.image_id){ %>
              <img width="40px" src="<%= value.imageFromVariant.medium_url %>" alt="<%= value.titleWithoutQuotes %>"
                title="<%= value.titleWithoutQuotes %>">
            <% }else{ %>
              <span>
                <%= value.title %>
              </span>
              <% } %>
      </button>
      <% }) %>
  </div>
</div>`;

export default templateCompiler(html, lodash);
